import { NavigateFunction } from "react-router-dom";

const redirectionTrigger = (navigate: NavigateFunction, path: string): void => {
  navigate(path);
  window.scrollTo(0, 0);
};

export default redirectionTrigger;
